import React, { Component }         from 'react';
/*global event, fdescribe*/
/*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
class Wrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {}

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        let { onBlur } = this.props;
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            onBlur()
        }
    }
    
    render() {
        let { children } = this.props;
        return (
            <div className="simprakit-modal-content" ref={this.setWrapperRef}>
                { children }
            </div>
        )
    }
}

export default Wrapper;